import React, { useState } from 'react'
import ModalTotalLoss from './index'
import apis from '../../FractionApi'
import { Batch } from '../../FractionTypes'

const useTotalLoss = ({ updateTableLot, resetFraction }) => {
  const [lossLot, setLossLot] = useState<Batch>()

  const handleClickTotalLoss = (lot: Batch) => {
    setLossLot(lot)
  }

  const handleTotalLoss = async (badgeUser: string) => {
    if (!badgeUser) throw new Error('Crachá do usuário inválido')

    return apis.setLotTotalLoss(lossLot?.id_lote, badgeUser)
      .then(() => {
        updateTableLot()
        resetFraction()
      })
      .catch((error) => {
        throw error
      })
  }

  const totalLossModalComponent = (badgeUser: string) => (
    <ModalTotalLoss
      lossLot={lossLot}
      cancelAction={() => setLossLot(undefined)}
      confirmAction={() => handleTotalLoss(badgeUser)}
    />
  )

  return { handleClickTotalLoss, totalLossModalComponent }
}

export default useTotalLoss
